module.exports = __webpack_public_path__ + "img/27.46f4aa44.png";